import request from "@/shared/api/request";
import type { CustomAxiosRequestConfig } from "@/shared/api/request";

import type {
  BindQQData,
  BindQQResponse,
  BindWechatData,
  BindWechatResponse,
  ChangeEmailByTokenData,
  ChangeEmailByTokenResponse,
  ChangePhoneByCodeData,
  ChangePhoneByCodeResponse,
  DeleteAccountResponse,
  GetConnectLinkParams,
  GetConnectLinkResponse,
  LoginData,
  LoginResponse,
  LoginByQQData,
  LoginByQQResponse,
  LoginByWechatData,
  LoginByWechatResponse,
  ResetPasswordByCodeData,
  ResetPasswordByCodeResponse,
  ResetPasswordData,
  ResetPasswordEmailsData,
  ResetPasswordEmailsResponse,
  ResetPasswordResponse,
  SendChangeEmailEmailData,
  SendChangeEmailEmailResponse,
  SendPhoneVerifySMSData,
  SendPhoneVerifySMSResponse,
  SendVerifyEmailData,
  SendVerifyEmailResponse,
  SetNewPasswordData,
  SetNewPasswordResponse,
  SignupData,
  SignupResponse,
  UnbindQQResponse,
  UnbindWechatResponse,
  UpdatePasswordData,
  UpdatePasswordResponse,
  VerifyEmailByTokenData,
  VerifyEmailByTokenResponse,
  UserInfoResponse,
} from "./types";

export const signup = (data: SignupData): Promise<SignupResponse> =>
  request.post("/api/v1/users", data);

export const login = (data: LoginData): Promise<LoginResponse> =>
  request.post("/api/v1/users/login", data);

export const getUserInfo = (): Promise<UserInfoResponse> =>
  request.get("/api/v1/users/me");

export const resetPasswordEmails = (
  data: ResetPasswordEmailsData,
): Promise<ResetPasswordEmailsResponse> =>
  request.post("/api/v1/users/reset-password-emails", data);

export const resetPassword = (
  data: ResetPasswordData,
): Promise<ResetPasswordResponse> =>
  request.put("/api/v1/users/reset-password-tokens", data);

export const resetPasswordByCode = (
  data: ResetPasswordByCodeData,
): Promise<ResetPasswordByCodeResponse> =>
  request.put("/api/v1/users/reset-password-codes", data);

export const sendChangeEmailEmail = (
  data: SendChangeEmailEmailData,
): Promise<SendChangeEmailEmailResponse> =>
  request.post("/api/v1/users/change-email-emails", data);

export const changeEmailByToken = (
  data: ChangeEmailByTokenData,
  config?: CustomAxiosRequestConfig,
): Promise<ChangeEmailByTokenResponse> =>
  request.put("/api/v1/users/emails", data, config);

export const deleteAccount = (): Promise<DeleteAccountResponse> =>
  request.delete("/api/v1/users/me", { confirm_data_deletion: true });

export const verifyEmailByToken = (
  data: VerifyEmailByTokenData,
  config?: CustomAxiosRequestConfig,
): Promise<VerifyEmailByTokenResponse> =>
  request.put("/api/v1/users/email-verify-status", data, config);

export const sendVerifyEmail = (
  data: SendVerifyEmailData = {},
): Promise<SendVerifyEmailResponse> =>
  request.post("/api/v1/users/verify-emails", data);

export const updatePassword = (
  data: UpdatePasswordData,
): Promise<UpdatePasswordResponse> =>
  request.put("/api/v1/users/passwords", data);

export const setNewPassword = (
  data: SetNewPasswordData,
): Promise<SetNewPasswordResponse> =>
  request.post("/api/v1/users/passwords", data);

export const sendPhoneVerifySMS = (
  data: SendPhoneVerifySMSData,
): Promise<SendPhoneVerifySMSResponse> =>
  request.post("/api/v1/users/verify-sms", data);

export const changePhoneByCode = (
  data: ChangePhoneByCodeData,
): Promise<ChangePhoneByCodeResponse> =>
  request.put("/api/v1/users/phones", data);

export const getQQConnectLink = (
  params?: GetConnectLinkParams,
): Promise<GetConnectLinkResponse> =>
  request.get("/api/v1/users/qq-links", params);

export const bindQQ = (data: BindQQData): Promise<BindQQResponse> =>
  request.post("/api/v1/users/qq", data);

export const unbindQQ = (): Promise<UnbindQQResponse> =>
  request.delete("/api/v1/users/qq");

export const loginByQQ = (data: LoginByQQData): Promise<LoginByQQResponse> =>
  request.post("/api/v1/users/qq-login", data);

export const getWechatQRCodeLink = (
  params?: GetConnectLinkParams,
): Promise<GetConnectLinkResponse> =>
  request.get("/api/v1/users/wechat-links", params);

export const bindWechat = (
  data: BindWechatData,
): Promise<BindWechatResponse> =>
  request.post("/api/v1/users/wechat", data);

export const unbindWechat = (): Promise<UnbindWechatResponse> =>
  request.delete("/api/v1/users/wechat");

export const unbindApple = (): Promise<Record<string, never>> =>
  request.delete("/api/v1/users/apple");

export const unbindGithub = (): Promise<Record<string, never>> =>
  request.delete("/api/v1/users/github");

export const loginByWechat = (
  data: LoginByWechatData,
): Promise<LoginByWechatResponse> =>
  request.post("/api/v1/users/wechat-login", data);
